exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright-info{color:#a1a1a1;margin-top:-15px;padding:5px;text-align:right}.copyright-info__tag{display:inline-block}@media print{.copyright-info__tag{display:inline-block;font-size:0.929rem}}\n", ""]);

// exports
exports.locals = {
	"copyright-info": "copyright-info",
	"copyright-info__tag": "copyright-info__tag"
};